import Rails from '@rails/ujs';
import { Config } from '../com/config';
import { Util } from '../com/util';

class Index {

    constructor() {
        this.CONFIG = new Config();
        this.FORM = document.forms['alertKeywordsForm'];
        this.FORM_KEYWORD = this.FORM['complaint_alert_keywords[keyword]'];
        this.FORM_LAST_ID = this.FORM['complaint_alert_keywords[last_id]'];
        this.FORM_PER_PAGE = this.FORM['complaint_alert_keywords[per_page]'];
        this.TBODY = document.getElementById('complaintAlertKeywordsTbody');
        this.TBODY_NOT_FOUND = document.getElementById('complaintAlertKeywordsTbodyNotFound');
        this.TBODY_SPINNER = document.getElementById('complaintAlertKeywordsTbodySpinner');
        this.IS_JSON_AVAILABLE_CREATE = true;
        this.IS_JSON_AVAILABLE_DELETE = true;
        this.IS_JSON_AVAILABLE_GET = true;
        this.JSON_HAS_MORE_GET = true;
    }


    handleBeforeSend(e) {
        if(e.target.dataset.ujs === 'create') {
            if(!this.IS_JSON_AVAILABLE_CREATE) {
                return;
            }
            this.IS_JSON_AVAILABLE_CREATE = false;
        } else if(e.target.dataset.ujs === 'delete') {
            if(!this.IS_JSON_AVAILABLE_DELETE) {
                return;
            }
            this.IS_JSON_AVAILABLE_DELETE = false;
        }
        Util.DelDomValidateError();
    }


    handleSuccess(e) {
        if(e.target.dataset.ujs === 'create') {
            const result = e.detail[0];
            this.generateHtmlAlertKeywords(new Array(result), true)
            this.FORM_KEYWORD.value = '';
        } else if(e.target.dataset.ujs === 'delete') {
            const tr = e.target.parentElement.parentElement;
            if(tr != null && tr.tagName === 'TR') {
                tr.remove();
            }
        }
        const trs = this.TBODY.children;
        if(trs.length === 0) {
            this.TBODY_NOT_FOUND.classList.remove('d-none');
        } else {
            this.TBODY_NOT_FOUND.classList.add('d-none');
        }
    }


    handleError(e) {
        if(e.target.dataset.ujs !== 'create' && e.target.dataset.ujs !== 'delete') {
            return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0)
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        if(msg != null && msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
        if(e.target.dataset.ujs === 'create') {
           const valid = detail.valid;
           if(valid != null) {
               if(valid['keyword'] != null && valid['keyword'][0] != null) {
                   Util.GenDomValidateError(this.FORM_KEYWORD, this.FORM_KEYWORD.placeholder + valid['keyword'][0]);
               }
           }
        }
        window.scrollTo(0, 0);
    }


    handleComplete(e) {
        if(e.target.dataset.ujs === 'create') {
            this.IS_JSON_AVAILABLE_CREATE = true;
        } else if(e.target.dataset.ujs === 'delete') {
            this.IS_JSON_AVAILABLE_DELETE = true;
        }
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e) }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e) }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e) }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e) }, false);
    }


    generateHtmlAlertKeywords(objects, insertBeforeFlag = false) {
        if(objects != null && objects.length > 0) {
            const f = document.createDocumentFragment();
            for(let i = 0; i < objects.length; i++) {
                const o = objects[i];
                const tr = document.createElement('TR');
                f.appendChild(tr);
                const idTd = document.createElement('TD');
                idTd.textContent = o.id;
                tr.appendChild(idTd);
                const kTd = document.createElement('TD');
                kTd.textContent = o.keyword;
                tr.appendChild(kTd);
                const actionTd = document.createElement('TD');
                actionTd.classList.add('actions-cell');
                tr.appendChild(actionTd);
                const deleteA = document.createElement('A');
                deleteA.classList.add('btn', 'btn-delete');
                deleteA.textContent = '削除';
                deleteA.href = this.FORM.action + '/' + o.id;
                deleteA.setAttribute('rel', 'nofollow');
                deleteA.dataset.remote = 'true';
                deleteA.dataset.method = 'delete';
                deleteA.dataset.confirm = "本当に削除してもよろしいですか？"
                deleteA.dataset.ujs = 'delete';
                actionTd.appendChild(deleteA);
            }
            if(insertBeforeFlag) {
                this.TBODY.insertBefore(f, this.TBODY.childNodes[0]);
            } else {
                this.TBODY.appendChild(f);
            }
        }
    }


    getComplaintAlertKeywords() {
        if(!this.IS_JSON_AVAILABLE_GET) {
            return;
        }
        this.IS_JSON_AVAILABLE_GET = false;
        this.TBODY_SPINNER.classList.remove('invisible');
        
        Rails.ajax({
            type: this.FORM.method,
            url: this.FORM.dataset.getAction,
            data: new FormData(this.FORM),
            success: (repsonse) => {
                if(repsonse != null && repsonse.length > 0) {
                    this.FORM_LAST_ID.value = repsonse[repsonse.length-1].id;
                    this.generateHtmlAlertKeywords(repsonse);
                } else {
                    if(this.FORM_LAST_ID.value === '0') {
                        this.TBODY_NOT_FOUND.classList.remove('d-none');
                    }
                    this.JSON_HAS_MORE_GET = false;
                }
            },
            error: (repsonse) => {
                if(repsonse != null && repsonse !== '') {
                    this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(repsonse), this.CONFIG.APP_MAIN.childNodes[0]);
                }
                console.log(repsonse);
            },
            complete: () => {
                this.IS_JSON_AVAILABLE_GET = true;
                this.TBODY_SPINNER.classList.add('invisible');
            }
        })
    }


    setUpScrollEventListener() {
        let scrollTimerId;
        window.addEventListener('scroll', (e) => {
            if(scrollTimerId != null) {
                clearTimeout(scrollTimerId);
            }
            scrollTimerId = setTimeout(() => { 
                const y = window.pageYOffset + window.innerHeight - (window.pageYOffset + this.TBODY.getBoundingClientRect().y);
                const height = this.TBODY.offsetHeight;
                if(height !== 0 && y > height * 0.9) {
                    if(this.IS_JSON_AVAILABLE_GET && this.JSON_HAS_MORE_GET) {
                        this.getComplaintAlertKeywords();
                    }
                }
            }, 500);
        }, false);
    }


    Run() {
        this.setUpRailsUjsEventListener();
        this.getComplaintAlertKeywords();
        this.setUpScrollEventListener();
    }

}
export { Index }
